import React from 'react'
import Image from "../../elements/Image";

const TestimonialOverview = ({ data }) => {
  return (
    <>
      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4 pb-28">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-16">
          <div className="relative w-1/2">
            <h4 className="text-xl font-semibold mb-5 text-primary uppercase">{data.subTitle}</h4>
            <h2 className="text-5xl text-white leading-tight font-semibold mb-6">{data.title}</h2>
            <div className="text-xl leading-8 text-secondary">
              <p>
                {data.description}
              </p>
            </div>
            <div className="relative flex flex-col gap-2 mt-8">
              <h3 className="text-xl font-semibold text-white">{data.reviewer.name}</h3>
              <p className="text-sm text-shades-04 font-semibold">{data.reviewer.position}</p>
            </div>
          </div>
          <div className="relative w-1/2">
            <div className="relative w-[660px] aspect-[5/4] rounded-2xl overflow-hidden">
              <Image
                src={data.image}
                width="100%"
                height="100%"
                alt=""
                classes="object-cover w-full h-full"
              />
              <div className="absolute inline-table bottom-7 left-5 right-0 bg-shades-06 rounded-2xl p-6 text-center">
                <div className="flex justify-center mb-3">
                  <div className="relative inline-flex text-gray-300 text-xl"> 
                    <div className="flex gap-1">
                      {[...Array(5)].map((_, index) => (
                        <i key={index} className={data.icon}></i>
                      ))}
                    </div>
 
                    <div
                      className="absolute top-0 left-0 flex gap-1 text-primary overflow-hidden"
                      style={{ width: "100%" }}
                    >
                      {[...Array(5)].map((_, index) => (
                        <i key={index} className={data.icon}></i>
                      ))}
                    </div>
                  </div> 
                </div>
                <h4 className="font-medium text-xl text-shades-02">{data.rating}</h4>
                <p className="text-xs text-shades-05 leading-8">{data.reviewsCount}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TestimonialOverview;